// MY 탭 통합 데이터 훅 — GET /api/mobile/me (2026-06-13 진단 P1: MyScreen mock 배선)
import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "./api";
import { useAuth } from "./useAuth";

export interface MeGrade {
  level: number;
  label: string; // 황소 라벨 (송아지~황금 황소)
  bullKey: string;
  color: string;
  progress: number; // 0~1 (현재 레벨 내 EXP 진척)
  currentExp: number;
  nextExp: number;
}

export interface MeData {
  empty: boolean;
  nickname: string | null;
  sinceDate: string | null; // ISO
  dPlus: number; // 가입 후 일수
  bull: number; // BULL 잔액 (화폐)
  cash_bull: number; // 구매분(충전·구독) — 활동분 = bull − cash_bull (#7 전환 가능분)
  todayEarn: number;
  monthEarn: number;
  postCount: number;
  recordDays: number;
  mbti: { code: string; label: string };
  grade: MeGrade;
}

export function useMe() {
  // 로그인 상태 구독 — 미로그인 시 fetch 비활성 (로그아웃 후 401 refetch·프로필 잔존 방지)
  const { user } = useAuth();
  return useQuery<MeData>({
    queryKey: ["me"],
    queryFn: () => apiFetch<MeData>("/api/mobile/me"),
    enabled: !!user,
    staleTime: 30_000, // 30초 — BULL/적립은 자주 안 바뀜
  });
}
